<template>
  <main class="page white-page login">
    <section class="slogan">
      <h1>你好!</h1>
      <p>欢迎来到申申享演示版</p>
    </section>
    <div class="login-form">
      <van-field
        v-model="tel"
        type="tel"
        clearable
        maxlength="13"
        placeholder="请输入手机号码"
        @input="formatTel"
      >
        <template #label><span class="region">+86</span></template>
      </van-field>
      <p class="field-desc">未注册的手机号验证后自动注册</p>
      <div class="agreement-line">
        <van-checkbox
          v-model="agreed"
          icon-size="15px"
          checked-color="#D3936A"
          shape="square"
          style="margin-top: 3px;"
        />
        <span>
          <span class="agreement-consent" @click="toggleAgreement">我已阅读并同意</span>
          <span class="agreement-names">《用户服务协议及隐私政策》</span></span
        >
      </div>
      <van-button
        class="primary-button"
        type="primary"
        size="large"
        @click="next"
        >获取验证码</van-button
      >
    </div>
  </main>
</template>

<script>
export default {
  name: "Login",
  data: () => ({ tel: "199 0000 1234", agreed: false }),
  methods: {
    formatTel(value) {
      const digits = value.replace(/\D/g, "").slice(0, 11);
      this.tel = digits.replace(/^(\d{3})(\d{0,4})(\d{0,4}).*/, (_, first, second, third) =>
        [first, second, third].filter(Boolean).join(" ")
      );
      return this.tel;
    },
    toggleAgreement() {
      this.agreed = this.agreed ? false : true;
    },
    next() {
      if (!/^1\d{10}$/.test(this.tel.replace(/\s/g, "")))
        return this.$toast("请输入正确的手机号码");
      if (!this.agreed) return this.$toast("请阅读并同意协议");
      sessionStorage.setItem("loginTel", this.tel.replace(/\s/g, ""));
      this.$router.push("/messageValidateCode");
    },
  },
};
</script>

<style lang="scss" scoped>
.login {
  padding: 40px 25px;
  color: #252525;
  min-height: 100vh;
  background-image: url('~@/assets/images/beijing@2x.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.slogan {
  margin-bottom: 80px;
}
.slogan h1,
.slogan p {
  font-size: 26px;
  font-weight: bold;
  line-height: 10px;
}
.login-form {
  margin-top: 0;
}
.login-form ::v-deep .van-cell {
  padding: 0 0 5px;
  background-color: transparent;
  font-size: 24px;
  line-height: 27px;
  border-bottom: 1px solid #c8cdd4;
}
.login-form ::v-deep .van-field__label {
  width: 44px;
  margin-right: 20px;
  font-weight: normal;
}
.login-form ::v-deep .van-field__control {
  color: #202020;
}
.region {
  display: block;
  color: #646566;
  font-size: 20px;
  text-align: center;
  background: #e2e3e2;
  height: 35px;
}
.field-desc {
  margin: 6px 0 1px;
  color: #919191;
  font-size: 13.5px;
  line-height: 14px;
}
.agreement-line {
  padding: 0;
  color: #222;
  font-size: 16.5px;
  margin-top: 40px;
  line-height: 24px;
}
.agreement-line ::v-deep .van-checkbox {
  margin-right: 8px;
  padding-top: 2px;
}
.agreement-names {
  color: #d3936a;
}
.primary-button {
  height: 50px;
  margin-top: 20px;
  border-radius: 6px !important;
  background: linear-gradient(90deg, #E1A379 0%, #B36E47 100%) !important;
  box-shadow: none;
  font-size: 17px;
}
</style>
